import type { AxiosInstance } from 'axios';
import type { UsageMetricRequest, UsageMetricResponse } from '@/types';

export const getUsageMetric = async (
  api: AxiosInstance,
  entity: string,
  metric: string,
  start: string,
  end: string,
  group_by: string[] | undefined = undefined,
  filters: Record<string, unknown> | undefined = undefined,
): Promise<UsageMetricResponse> => {
  const resp = await api.post<UsageMetricResponse>('/admin/usage/metric', {
    entity,
    metric,
    group_by,
    filters,
    time_range: {
      start,
      end,
    },
  } as UsageMetricRequest);
  return resp.data;
};
